// import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
// // import { userLogin } from "../auth/authSlice";

// export const apiSlice = createApi({
//     reducerPath: 'hrmsApi',
//     baseQuery: fetchBaseQuery({
//         baseUrl: API_URL,
//         prepareHeaders: async (headers, { getState, endpoint }) => {

//             const token = getState()?.Auth?.token || localStorage.getItem('knighthuntToken')

//             if (token) {
//                 headers.set('authorization', `berar ${token}`);
//                 // headers.set("Content-Type", `multipart/form-data`);

//             }

//             return headers;
//         },
//     }),
//     tagTypes: ['showEstablishment', 'getBranch'],
//     endpoints: (builder) => ({}),
// });

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userLogout } from "./auth/authSlice";

export let API_URL = "https://dev-api.knighthunt.com/api/v1";
// export let API_URL = "http://localhost:8000/api/v1";

const { hostname } = window.location;
// if (hostname === 'localhost' || hostname === '127.0.0.1') {
//   API_URL = 'http://localhost:8000/api/v1';
// } else {
//   API_URL = 'https://knighthunt-api.techwens.in/api/v1';
// }
// API_URL = 'https://knighthunt-api.techwens.in/api/v1';
// API_URL = "http://localhost:8000/api/v1";
// import { setCredentials, logOut } from '../../features/auth/authSlice'

const baseQuery = fetchBaseQuery({
  baseUrl: API_URL,
  credentials: "include",
  prepareHeaders: async (headers, { getState }) => {
    const token =
      getState()?.Auth?.token || localStorage.getItem("knighthuntToken");

    if (token) {
      headers.set(
        "authorization",
        token.startsWith("Bearer") ? token : `Bearer ${token}`
      );
      // headers.set("authorization", `berar ${token}`);
      // headers.set("Content-Type", `multipart/form-data`);
    }

    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result?.error?.data?.additional?.alive?.toString() === "false") {
    console.log(
      "resulerrt",
      result?.error?.data?.additional?.alive?.toString() === "false"
    );

    api.dispatch(userLogout());
    localStorage.removeItem("knighthuntToken");
    localStorage.removeItem("knighthuntUserInfo");
    // navigate('/login')
  }
  // if (result?.error?.originalStatus === 403) {
  //     console.log('sending refresh token')
  //     // send refresh token to get new access token
  //     const refreshResult = await baseQuery('/refresh', api, extraOptions)
  //     console.log(refreshResult)
  //     if (refreshResult?.data) {
  //         const user = api.getState().auth.user
  //         // store the new token
  //         // api.dispatch(setCredentials({ ...refreshResult.data, user }))
  //         // retry the original query with new access token
  //         result = await baseQuery(args, api, extraOptions)
  //     } else {
  //     }
  // }

  return result;
};

export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    "Products",
    "Product",
    "coupon",
    "Order",
    "faq",
    "specification",
    "returnPolicy",
    "termsCondition",
    "ProductsList",
    "orderStatus",
  ],
  endpoints: (builder) => ({}),
});
